import { render, staticRenderFns } from "./promo.vue?vue&type=template&id=72cb8f78&scoped=true"
import script from "./promo.vue?vue&type=script&lang=js"
export * from "./promo.vue?vue&type=script&lang=js"
import style0 from "./promo.vue?vue&type=style&index=0&id=72cb8f78&prod&lang=less"
import style1 from "./promo.vue?vue&type=style&index=1&id=72cb8f78&prod&scoped=true&lang=less"
import style2 from "./promo.vue?vue&type=style&index=2&id=72cb8f78&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cb8f78",
  null
  
)

export default component.exports